import { methods } from '../../../libs/service-caller';

export class DomainAction {
    domain = "";
    action = "";
    static methods = methods;
    method = null;

    constructor(domain, action, method) {
        this.domain = domain;
        this.action = action;
        this.method = method;
    }
}

export class DomainActionSubscriber extends DomainAction {
    constructor(domain, action, method) {
        super(domain, action, method);
    }
}